import React from 'react';

const Levels = () => {
  const levels = [
    {
      id: 1,
      name: 'New Host',
      class: 'level-new',
      price: 'Rp.20.000/hari',
      duration: 'Durasi 2 jam (live muka)',
      description: 'Program khusus untuk host baru selama 10 hari pertama'
    },
    {
      id: 2,
      name: 'Level A',
      class: 'level-a',
      price: 'Rp.50.000/hari',
      duration: '',
      description: 'Level awal untuk host pemula dengan performa yang baik'
    },
    {
      id: 3,
      name: 'Level S',
      class: 'level-s',
      price: 'Rp.100.000/hari',
      duration: '',
      description: 'Level menengah untuk host dengan pengalaman dan performa konsisten'
    },
    {
      id: 4,
      name: 'Level SS',
      class: 'level-ss',
      price: 'Rp.180.000/hari',
      duration: '',
      description: 'Level tertinggi untuk host dengan performa luar biasa dan loyalitas tinggi'
    }
  ];

  return (
    <section id="levels">
      <div className="container">
        <h2 className="section-title">Level & Gaji Pokok</h2>
        <div className="levels">
          {levels.map(level => (
            <div key={level.id} className={`level-card ${level.class}`}>
              <h3>{level.name}</h3>
              <div className="price">{level.price}</div>
              {level.duration && <div className="duration">{level.duration}</div>}
              <p>{level.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Levels;
